import { hashMap } from 'mori';

export default function maybeBuildButton({ title, link, onClick }) {
  if (!link || !title) {
    return null;
  }

  return hashMap('title', title, 'link', link, 'onClick', onClick);
}
